import 'index.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from 'components/App'
import { Auth0Provider } from '@auth0/auth0-react'
import AuthGuard from 'components/AuthGuard'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }}>
    <AuthGuard>
      <QueryClientProvider client={new QueryClient()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </AuthGuard>
  </Auth0Provider>,
)
